export default __webpack_public_path__ + "static/aboutUs-bab43a563c8df73154707b162217edc2.svg";